import { CommonViewController } from './CommonViewController';
import { UserDetailsService } from 'fides-angularjs-components/src/fts-services/fts-user-details-service';
import { AccountService } from '../services/AccountService';
import { REACT_AH_CRUMBS_DETAIL_DATA_READY } from "../components/react/AwApplicationHeaderHelpers/AwApplicationHeaderHelpers";

/** @ngInject */
export class DetailViewController extends CommonViewController {

    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);
        this.$rootScope = this.ftsMainDependencies.$rootScope;
        this.$scope.detailPromise = null;
        this.accountService = new AccountService(userService);
        if(this.sessionPersistance.promise) {
            this.sessionPersistance.promise.then(() => {
                this.initSessionPersistanceDependencies(arsMainDependencies.$stateParams);
            });
        } else {
            this.sessionPersistance.init(new UserDetailsService(userService)).then(() => {
                this.initSessionPersistanceDependencies(arsMainDependencies.$stateParams);
            });
        }
    }

    setReactCrumbProps() {
        this.$scope.$on(REACT_AH_CRUMBS_DETAIL_DATA_READY, (e, accountInfo) => {
            super.setReactCrumbProps(accountInfo);
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initSessionPersistanceDependencies($stateParams) {
        // overwritten by childs
    }

    initDateRange() {
        this.maxDate = new Date();
        this.minDate = new Date();
        this.minDate.setDate(this.minDate.getDate() - 80);
    }
}
